module.exports = __webpack_public_path__ + "static/media/zillow-logo.3813c4b8.svg";